module.exports = __webpack_public_path__ + "img/BE0889389238.7688c019.png";